<template>
  <div>
    <v-toolbar
      light
      color="white"
      class="elevation-2"
    >
      <v-toolbar-title>Klienci</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-tooltip left>
        <v-btn
          slot="activator"
          @click.prevent="addNewClient" icon>
          <v-icon color="primary">person_add</v-icon>
        </v-btn>
        <span>Dodaj klienta</span>
      </v-tooltip>

    </v-toolbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'clients-toolbar',
  methods: {
    ...mapActions('clients', [
      'setDialogVisbility',
    ]),
    addNewClient() {
      this.setDialogVisbility({ type: 'add' });
    },
  },
};
</script>
